
window.addEventListener('scroll', function() {
  const headerElement = document.querySelector('.shopify-section--header .Header');
  const headerIcons = document.querySelector('.Header__FlexItem.header_icons');
  const headerWrapper = document.querySelector('.Header__Wrapper');
  const headerDropDownMenu = document.querySelector('.Header__MainNav .DropdownMenu');
  
  if (document.documentElement.scrollTop <= 40) {
    headerElement.style.borderRadius = '10px';
    headerIcons.style.position = 'absolute';
    headerIcons.style.paddingBlock = '4px';
    headerWrapper.style.paddingBlock = '8px';
    headerDropDownMenu.style.borderRadius = '10px';

    if (window.innerWidth <= 640) {
      headerIcons.style.right = '50px';
    } else if (window.innerWidth >= 641 && window.innerWidth <= 1079) {
    headerIcons.style.right = '50px';
    } else {
      headerIcons.style.right = '10px';
    }

  } else {
    headerElement.style.borderRadius = '0 0 10px 10px';
    headerIcons.style.position = 'relative';
    headerIcons.style.paddingBlock = '0';
    headerWrapper.style.paddingBlock = '3px';
    headerDropDownMenu.style.borderRadius = '0 0 10px 10px';

    if (window.innerWidth <= 640) {
      headerIcons.style.right = '16px';
    } else if (window.innerWidth >= 641 && window.innerWidth <= 1079) {
      headerIcons.style.right = '14px';
    } else {
      headerIcons.style.right = '-3px';
    }

  }
});


document.addEventListener('DOMContentLoaded', () => {
  const buttons = [
    document.querySelector('.poyo-cart'),
    document.querySelector('.poyo-login'),
    document.querySelector('.poyo-search'),
    document.querySelector('#poyo_latest_info'),
    document.querySelector('#poyo_category_contents'),
    document.querySelector('#poyo_monitor_guide'),
    document.querySelector('#poyo_sns_contents'),
    document.querySelector('#poyo_sns_x'),
    document.querySelector('#poyo_sns_insta'),
    document.querySelector('#poyo_movie_content'),
    document.querySelector('#poyo_blog_staff'),
    document.querySelector('#poyo_about'),
    document.querySelector('#poyo_login'),
    document.querySelector('#poyo_register'),
    document.querySelector('#poyo_change_pw_submit'),
    document.querySelector('#poyo_reset_pw_submit'),
    document.querySelector('#poyo_register_submit'),
    document.querySelector('#poyo_empty-state__Action')
  ];
  
  buttons.forEach(btn => {
    if (btn) {
      btn.addEventListener('mouseenter', e => {
        e.target.classList.add('is-poyo');
        console.log("Class ''is-poyo' added");
      });
      
      btn.addEventListener('mouseup', e => {
        e.target.classList.add('is-poyo');
        console.log("Class ''is-poyo' added");
      });
      
      btn.addEventListener('animationend', e => {
        e.target.classList.remove('is-poyo');
        console.log("Class ''is-poyo' removed");
      });
    }
  });
});

// 2024/12/11
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const continueShoppingButton = document.querySelector('#poyo_continue_shopping');
    const checkoutButton = document.querySelector('#poyo_checkout');

    if (continueShoppingButton) {
      attachListeners(continueShoppingButton);
    }

    if (checkoutButton) {
      attachListeners(checkoutButton);
    }
  }, 1000); // 1秒待機
});

function attachListeners(btn) {
  btn.addEventListener('mouseenter', e => {
    e.target.classList.add('is-poyo');
    console.log("Class 'is-poyo' added");
  });

  btn.addEventListener('mouseup', e => {
    e.target.classList.add('is-poyo');
    console.log("Class 'is-poyo' added");
  });

  btn.addEventListener('animationend', e => {
    e.target.classList.remove('is-poyo');
    console.log("Class 'is-poyo' removed");
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const stickyCartRoot = document.querySelector('[data-sticky-cart-root]');
  const stickyCartForm = stickyCartRoot ? stickyCartRoot.querySelector('form[action*="/cart/add"]') : null;
  const stickyVariantSelect = stickyCartRoot ? stickyCartRoot.querySelector('[data-sticky-variant-select]') : null;
  const stickyQuantityInput = stickyCartRoot ? stickyCartRoot.querySelector('[data-sticky-quantity-input]') : null;
  const stickyAddToCartButton = stickyCartRoot ? stickyCartRoot.querySelector('[data-sticky-add-to-cart]') : null;
  const mainProductSection = document.querySelector('[data-section-type="product"]');
  const mainProductForm = mainProductSection ? mainProductSection.querySelector('.Product__Info form[action*="/cart/add"]') : null;
  const mainBuyButtons = mainProductForm ? mainProductForm.querySelector('.ProductForm__BuyButtons') : null;
  const mainAddToCartButton = mainProductForm ? mainProductForm.querySelector('.ProductForm__AddToCart') : null;
  const mainQuantityInput = mainProductForm ? mainProductForm.querySelector('[name="quantity"]') : null;
  const productJsonElement = mainProductSection ? mainProductSection.querySelector('[data-product-json]') : null;

  if (!stickyCartRoot || !stickyCartForm || !mainProductSection || !mainProductForm || !mainBuyButtons) {
    return;
  }

  const productJson = productJsonElement ? JSON.parse(productJsonElement.textContent) : null;
  const variantsById = {};
  const escapeSelectorValue = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  };

  if (productJson && productJson.product && Array.isArray(productJson.product.variants)) {
    productJson.product.variants.forEach((variant) => {
      variantsById[String(variant.id)] = variant;
    });
  }

  let isSyncing = false;
  let currentMainVariantId = '';
  let isMainBuyButtonsVisible = true;

  const setQuantityValue = (input, value) => {
    if (!input) {
      return;
    }

    const parsedValue = Math.max(parseInt(value, 10) || 1, 1);
    input.value = parsedValue;
  };

  const getMainVariantId = (fallbackVariantId) => {
    if (fallbackVariantId) {
      return fallbackVariantId;
    }

    if (currentMainVariantId) {
      return currentMainVariantId;
    }

    const mainNoJsSelect = mainProductSection.querySelector('.no-js select[name="id"]');

    if (mainNoJsSelect && mainNoJsSelect.value) {
      return mainNoJsSelect.value;
    }

    const hiddenVariantInput = mainProductForm.querySelector('input[name="id"]');
    return hiddenVariantInput ? hiddenVariantInput.value : '';
  };

  const syncButtonState = () => {
    if (!mainAddToCartButton || !stickyAddToCartButton) {
      return;
    }

    stickyAddToCartButton.innerHTML = mainAddToCartButton.innerHTML;
    stickyAddToCartButton.className = mainAddToCartButton.className;
    stickyAddToCartButton.setAttribute('data-sticky-add-to-cart', '');
    stickyAddToCartButton.setAttribute('data-use-primary-button', mainAddToCartButton.getAttribute('data-use-primary-button') || 'true');

    if (mainAddToCartButton.hasAttribute('disabled')) {
      stickyAddToCartButton.setAttribute('disabled', 'disabled');
      stickyAddToCartButton.removeAttribute('data-action');
    } else {
      stickyAddToCartButton.removeAttribute('disabled');

      if (mainAddToCartButton.hasAttribute('data-action')) {
        stickyAddToCartButton.setAttribute('data-action', mainAddToCartButton.getAttribute('data-action'));
      } else {
        stickyAddToCartButton.removeAttribute('data-action');
      }
    }
  };

  const syncFromMain = (variantIdOverride) => {
    if (isSyncing) {
      return;
    }

    isSyncing = true;

    const mainVariantId = getMainVariantId(variantIdOverride);

    if (stickyVariantSelect && mainVariantId) {
      const matchingOption = stickyVariantSelect.querySelector(`option[value="${mainVariantId}"]`);

      if (matchingOption) {
        stickyVariantSelect.value = mainVariantId;
        currentMainVariantId = mainVariantId;
      }
    }

    if (mainQuantityInput && stickyQuantityInput) {
      setQuantityValue(stickyQuantityInput, mainQuantityInput.value);
    }

    syncButtonState();

    isSyncing = false;
  };

  const syncToMain = () => {
    if (isSyncing) {
      return;
    }

    isSyncing = true;

    if (stickyVariantSelect) {
      const stickyVariantId = stickyVariantSelect.value;
      const targetVariant = variantsById[stickyVariantId];

      if (targetVariant) {
        ['option1', 'option2', 'option3'].forEach((optionKey, index) => {
          const optionValue = targetVariant[optionKey];

          if (!optionValue) {
            return;
          }

          const radioSelector = `.ProductForm__Option [data-option-position="${index + 1}"][value="${escapeSelectorValue(optionValue)}"]`;
          const matchingRadio = mainProductForm.querySelector(radioSelector);

          if (matchingRadio && !matchingRadio.checked) {
            matchingRadio.checked = true;
            matchingRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        const mainNoJsSelect = mainProductSection.querySelector('.no-js select[name="id"]');
        if (mainNoJsSelect) {
          mainNoJsSelect.value = stickyVariantId;
        }

        const mainHiddenVariantInput = mainProductForm.querySelector('input[name="id"]');
        if (mainHiddenVariantInput) {
          mainHiddenVariantInput.value = stickyVariantId;
        }
      }
    }

    if (stickyQuantityInput && mainQuantityInput) {
      setQuantityValue(mainQuantityInput, stickyQuantityInput.value);
      mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    isSyncing = false;

    window.setTimeout(syncFromMain, 0);
  };

  const toggleStickyCartVisibility = () => {
    stickyCartRoot.style.display = isMainBuyButtonsVisible ? 'none' : 'block';
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target !== mainBuyButtons) {
        return;
      }

      if (entry.isIntersecting) {
        isMainBuyButtonsVisible = true;
        stickyCartRoot.classList.remove('fixed_cart_detail_show');
      } else {
        isMainBuyButtonsVisible = false;
        stickyCartRoot.classList.add('fixed_cart_detail_show');
      }

      toggleStickyCartVisibility();
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0
  });

  observer.observe(mainBuyButtons);

  if (mainQuantityInput) {
    mainQuantityInput.addEventListener('input', syncFromMain);
    mainQuantityInput.addEventListener('change', syncFromMain);
  }

  mainProductForm.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');

    if (!quantityButton) {
      return;
    }

    window.setTimeout(syncFromMain, 0);
  });

  if (stickyQuantityInput) {
    stickyQuantityInput.addEventListener('input', syncToMain);
    stickyQuantityInput.addEventListener('change', syncToMain);
  }

  stickyCartForm.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');

    if (!quantityButton) {
      return;
    }

    window.setTimeout(syncToMain, 0);
  });

  if (stickyVariantSelect) {
    stickyVariantSelect.addEventListener('change', syncToMain);
  }

  mainProductSection.addEventListener('variant:changed', (event) => {
    const variant = event.detail && event.detail.variant;

    if (stickyVariantSelect && variant && variant.id) {
      const variantId = String(variant.id);
      const matchingOption = stickyVariantSelect.querySelector(`option[value="${variantId}"]`);

      if (matchingOption) {
        stickyVariantSelect.value = variantId;
      }

      currentMainVariantId = variantId;
    }

    syncFromMain(currentMainVariantId);
  });

  if (mainAddToCartButton) {
    const buttonObserver = new MutationObserver(() => {
      syncButtonState();
    });

    buttonObserver.observe(mainAddToCartButton, {
      attributes: true,
      attributeFilter: ['class', 'disabled', 'data-action'],
      childList: true,
      subtree: true
    });
  }

  stickyCartRoot.style.display = 'none';
  syncFromMain();
  toggleStickyCartVisibility();
  window.addEventListener('scroll', toggleStickyCartVisibility);
});


// モーダルを開くボタンの要素を取得
var openModalBtns = document.querySelectorAll(".openModalBtn");

// モーダル要素を取得
var modals = document.querySelectorAll(".modal");

// モーダルを開くボタンがクリックされたときの処理
openModalBtns.forEach(function(openModalBtn, index) {
    openModalBtn.addEventListener("click", function() {
        // モーダルを表示する際に"show"クラスを追加してアニメーションをトリガー
        modals[index].classList.add("show");
    });
});

// モーダルの背景をクリックしたときの処理（モーダルを閉じる）
window.addEventListener("click", function(event) {
    modals.forEach(function(modal, index) {
        if (event.target == modal) {
          // モーダルを非表示にする際に"show"クラスを削除してアニメーションをトリガー
          modal.classList.remove("show");

          // モーダルが閉じられたときに動画を停止する
          var iframe = modals[index].querySelector("iframe");
          if (iframe) {
            var videoSrc = iframe.src;
            // 動画のsrc属性を空にして一時停止させる
            iframe.src = "";
            // src属性を元に戻すことで動画を停止させる
            iframe.src = videoSrc;
          }
        }
    });
});
